<script setup>
import { useAttrs } from 'vue';
import pananaCloudSymbol from 'dashboard/assets/images/panana-cloud-symbol.svg';

const attrs = useAttrs();
</script>

<template>
  <img v-once v-bind="attrs" :src="pananaCloudSymbol" alt="Panana Cloud" />
</template>
